import axios from 'axios';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL ?? '';
const BASE_URL = `${BACKEND_URL}/api/content`;

class ContentService {
  async getAll() {
    return axios.get(`${BASE_URL}/`);
  }

  async getByType(contentType) {
    return axios.get(`${BASE_URL}/${contentType}`);
  }

  async getAppearance() {
    return this.getByType('appearance');
  }
}

export default new ContentService();